import classNames from 'classnames';
import { Document } from '@/entities/document';
import DefaultLayout from '../../layout/DefaultLayout';
import Breadcrumbs, { AppBreadcrumbs } from '../../shared/Breadcrumbs';
import DocumentLink from '../../shared/DocumentLink';
import Typografed from '../../shared/Typografed';

type Props = React.HTMLAttributes<HTMLElement> & {
    breadcrumbs: AppBreadcrumbs;
    title: string;
    document?: Document | null;
    aboveTitleSlot?: React.ReactNode;
};

function PageWelcome({ breadcrumbs, title, document, aboveTitleSlot, ...props }: Props) {
    return (
        <div
            {...props}
            className={classNames('page-welcome__section js-header-theme-trigger', props.className)}
            data-theme="dark"
            id="top"
        >
            <div className="page-welcome__wrapper wrapper">
                <div className="page-welcome__top">
                    <Breadcrumbs className="participation-breadcrumbs" breadcrumbs={breadcrumbs} />
                </div>
                {aboveTitleSlot && <div className="page-welcome__above-title">{aboveTitleSlot}</div>}
                <div className="page-welcome__bottom">
                    <h1 className="page-welcome__title h2">
                        <Typografed>{title}</Typografed>
                    </h1>
                    {document && <DocumentLink document={document} />}
                </div>
            </div>
        </div>
    );
}

export default PageWelcome;
